var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "challenges-report-page" }, [
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-md-2" },
        [
          _c(
            "flip-card",
            { attrs: { id: "db-readers-in-schools" } },
            [
              _c("dash-box", {
                attrs: {
                  slot: "front",
                  title: "Schools Registered",
                  value: _vm.totalOrgs.total,
                  active_value: _vm.totalOrgs.active
                },
                slot: "front"
              }),
              _c(
                "div",
                {
                  staticClass: "dashbox__help",
                  attrs: { slot: "back" },
                  slot: "back"
                },
                [
                  _c("strong", [
                    _vm._v(_vm._s(_vm.totalOrgs.total.toLocaleString("en")))
                  ]),
                  _vm._v(" schools have registered, "),
                  _c("i", { staticClass: "fa fa-bolt" }),
                  _vm._v(" "),
                  _c("strong", [
                    _vm._v(_vm._s(_vm.totalOrgs.active.toLocaleString("en")))
                  ]),
                  _vm._v(" have at least 1 child who has read something.")
                ]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-md-2" },
        [
          _c(
            "flip-card",
            { attrs: { id: "db-readers-in-schools" } },
            [
              _c("dash-box", {
                attrs: {
                  slot: "front",
                  title: "Parents Registered",
                  value: _vm.totalUsers.total,
                  active_value: _vm.totalUsers.active
                },
                slot: "front"
              }),
              _c(
                "div",
                {
                  staticClass: "dashbox__help",
                  attrs: { slot: "back" },
                  slot: "back"
                },
                [
                  _c("strong", [
                    _vm._v(_vm._s(_vm.totalUsers.total.toLocaleString("en")))
                  ]),
                  _vm._v(" parents have registered, "),
                  _c("i", { staticClass: "fa fa-bolt" }),
                  _vm._v(" "),
                  _c("strong", [
                    _vm._v(_vm._s(_vm.totalUsers.active.toLocaleString("en")))
                  ]),
                  _vm._v(" have at least 1 child who has read something.")
                ]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-md-2" },
        [
          _c(
            "flip-card",
            { attrs: { id: "db-readers-registered" } },
            [
              _c("dash-box", {
                attrs: {
                  slot: "front",
                  title: "Readers Registered",
                  value: _vm.totalReaders.total,
                  active_value: _vm.totalReaders.active
                },
                slot: "front"
              }),
              _c(
                "div",
                {
                  staticClass: "dashbox__help",
                  attrs: { slot: "back" },
                  slot: "back"
                },
                [
                  _c("strong", [
                    _vm._v(_vm._s(_vm.totalReaders.total.toLocaleString("en")))
                  ]),
                  _vm._v(" children are in the challenge, "),
                  _c("i", { staticClass: "fa fa-bolt" }),
                  _vm._v(" "),
                  _c("strong", [
                    _vm._v(_vm._s(_vm.totalReaders.active.toLocaleString("en")))
                  ]),
                  _vm._v(" have read something.")
                ]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-md-2" },
        [
          _c(
            "flip-card",
            { attrs: { id: "db-readers-in-schools" } },
            [
              _c("dash-box", {
                attrs: {
                  slot: "front",
                  title: "Readers Associated to a School",
                  value: _vm.readersInOrgs.total,
                  active_value: _vm.readersInOrgs.active
                },
                slot: "front"
              }),
              _c(
                "div",
                {
                  staticClass: "dashbox__help",
                  attrs: { slot: "back" },
                  slot: "back"
                },
                [
                  _c("strong", [
                    _vm._v(_vm._s(_vm.readersInOrgs.total.toLocaleString("en")))
                  ]),
                  _vm._v(" children are associated with a school, "),
                  _c("i", { staticClass: "fa fa-bolt" }),
                  _vm._v(" "),
                  _c("strong", [
                    _vm._v(
                      _vm._s(_vm.readersInOrgs.active.toLocaleString("en"))
                    )
                  ]),
                  _vm._v(" have read something.")
                ]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-md-2" },
        [
          _c(
            "flip-card",
            { attrs: { id: "db-readers-not-in-school" } },
            [
              _c("dash-box", {
                attrs: {
                  slot: "front",
                  title: "Readers not in School",
                  value: _vm.readersNotInOrgs.total,
                  active_value: _vm.readersNotInOrgs.active
                },
                slot: "front"
              }),
              _c(
                "div",
                {
                  staticClass: "dashbox__help",
                  attrs: { slot: "back" },
                  slot: "back"
                },
                [
                  _c("strong", [
                    _vm._v(
                      _vm._s(_vm.readersNotInOrgs.total.toLocaleString("en"))
                    )
                  ]),
                  _vm._v(" children are "),
                  _c("strong", [_c("u", [_vm._v("not")])]),
                  _vm._v(" associated with a school, "),
                  _c("i", { staticClass: "fa fa-bolt" }),
                  _vm._v(" "),
                  _c("strong", [
                    _vm._v(
                      _vm._s(_vm.readersNotInOrgs.active.toLocaleString("en"))
                    )
                  ]),
                  _vm._v(" have read something.")
                ]
              )
            ],
            1
          )
        ],
        1
      ),
      _c("div", { staticClass: "col-md-2" }, [
        _c(
          "div",
          { staticClass: "btn-group", staticStyle: { width: "100%" } },
          [
            _c(
              "button",
              {
                staticClass: "btn btn-primary dropdown-toggle",
                staticStyle: { width: "100%" },
                attrs: {
                  type: "button",
                  "data-toggle": "dropdown",
                  disabled: _vm.isExporting
                }
              },
              [
                _vm._v(
                  " " +
                    _vm._s(_vm.isExporting ? "Exporting" : "Export Data") +
                    " "
                ),
                _vm.isExporting
                  ? _c("i", { staticClass: "fa fa-spin fa-spinner ml-2" })
                  : _c("span", { staticClass: "caret ml-2" })
              ]
            ),
            _c("ul", { staticClass: "dropdown-menu" }, [
              _c("li", [
                _c(
                  "a",
                  {
                    attrs: { href: "#" },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.getSchoolsCSV($event)
                      }
                    }
                  },
                  [_vm._v("Schools CSV")]
                )
              ]),
              _c("li", [
                _c(
                  "a",
                  {
                    attrs: { href: "#" },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.getReadersCSV($event)
                      }
                    }
                  },
                  [_vm._v("Readers CSV")]
                )
              ])
            ])
          ]
        ),
        _c(
          "div",
          { staticClass: "user-filters mt-4", staticStyle: { float: "right" } },
          [
            _c("div", { staticClass: "user-filter user-filter__break" }, [
              _vm._m(0),
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.challenge,
                      expression: "challenge"
                    }
                  ],
                  attrs: { name: "challenges", id: "challenges" },
                  on: {
                    change: [
                      function($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function(o) {
                            return o.selected
                          })
                          .map(function(o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.challenge = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      },
                      _vm.refreshData
                    ]
                  }
                },
                _vm._l(_vm.challenges, function(ch) {
                  return _c(
                    "option",
                    { key: ch.id, domProps: { value: ch.slug } },
                    [_vm._v(_vm._s(_vm._f("uppercase")(ch.slug)))]
                  )
                }),
                0
              )
            ])
          ]
        )
      ])
    ]),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-lg-6" }, [
        _c(
          "h2",
          {
            staticStyle: {
              "font-weight": "200",
              color: "#224450",
              "text-shadow": "1px 1px 0 #ffffffb3"
            }
          },
          [_vm._v("Partner Referrals")]
        ),
        _c(
          "table",
          {
            staticClass: "table table-striped table-hover table-condensed",
            staticStyle: {
              background: "white",
              "box-shadow": "2px 2px 3px 0px #c7d5e6"
            }
          },
          [
            _vm._m(1),
            _c(
              "tbody",
              _vm._l(_vm.partners, function(p, i) {
                return _c("tr", { key: i }, [
                  _c("td", [_vm._v(_vm._s(p.name))]),
                  _c("td", [_vm._v(_vm._s(p.organisations_referred_count))]),
                  _c("td", [_vm._v(_vm._s(p.users_referred_count))])
                ])
              }),
              0
            )
          ]
        )
      ]),
      _c("div", { staticClass: "col-lg-6" }, [
        _c("div", [
          _c(
            "h2",
            {
              staticStyle: {
                "font-weight": "200",
                color: "#224450",
                "text-shadow": "1px 1px 0 #ffffffb3"
              }
            },
            [_vm._v("Regional Breakdown")]
          ),
          _c(
            "table",
            {
              staticClass: "table table-striped table-hover table-condensed",
              staticStyle: {
                background: "white",
                "box-shadow": "2px 2px 3px 0px #c7d5e6"
              }
            },
            [
              _vm._m(2),
              _c(
                "tbody",
                _vm._l(_vm.regions, function(r, i) {
                  return _c("tr", { key: i }, [
                    _c("td", [_vm._v(_vm._s(r || "Unknown Region"))]),
                    _c("td", [_vm._v(_vm._s(_vm.orgRegionStats(r).total))]),
                    _c("td", [
                      _vm._v(_vm._s(_vm.totalUsers.regional[r].total))
                    ]),
                    _c("td", [
                      _vm._v(_vm._s(_vm.totalReaders.regional[r].total))
                    ])
                  ])
                }),
                0
              )
            ]
          )
        ]),
        _c("div", [
          _c(
            "h2",
            {
              staticStyle: {
                "font-weight": "200",
                color: "#224450",
                "text-shadow": "1px 1px 0 #ffffffb3"
              }
            },
            [_vm._v("Certificates & Stars")]
          ),
          _c(
            "table",
            {
              staticClass: "table table-striped table-hover table-condensed",
              staticStyle: {
                background: "white",
                "box-shadow": "2px 2px 3px 0px #c7d5e6"
              }
            },
            [
              _vm._m(3),
              _c(
                "tbody",
                _vm._l(_vm.certificates, function(c, i) {
                  return _c("tr", { key: i }, [
                    _c(
                      "td",
                      {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip",
                            value: {
                              content: c.description,
                              placement: "auto-start"
                            },
                            expression:
                              "{content:c.description, placement: 'auto-start'}"
                          }
                        ]
                      },
                      [_vm._v(_vm._s(c.name))]
                    ),
                    _c("td", [_vm._v(_vm._s(c.count))])
                  ])
                }),
                0
              )
            ]
          )
        ])
      ])
    ]),
    _c("div", { staticClass: "row" }, [
      _vm._m(4),
      _c(
        "div",
        { staticClass: "col-md-12" },
        [
          _c("vue-good-table", {
            attrs: {
              styleClass: "vgt-table striped",
              theme: "auris-admin",
              columns: _vm.columns,
              rows: _vm.data,
              totalRows: _vm.data.length,
              "pagination-options": {
                enabled: true,
                mode: "records",
                perPage: 25,
                position: "bottom",
                perPageDropdown: [10, 25, 50, 100],
                dropdownAllowAll: false,
                setCurrentPage: 1,
                nextLabel: "next",
                prevLabel: "prev",
                rowsPerPageLabel: "Rows per page",
                ofLabel: "of",
                pageLabel: "page", // for 'pages' mode
                allLabel: "All"
              },
              "search-options": {
                enabled: true,
                placeholder: "Search this table"
              },
              "sort-options": {
                enabled: true,
                initialSortBy: { field: "name", type: "asc" }
              }
            },
            on: { "on-sort-change": _vm.handleSortChange },
            scopedSlots: _vm._u([
              {
                key: "table-row",
                fn: function(props) {
                  return [
                    props.column.field == "name"
                      ? _c("span", [
                          _c(
                            "a",
                            {
                              attrs: {
                                href:
                                  "/challenges/" +
                                  _vm.challenge +
                                  "/organisations/" +
                                  props.row.id
                              }
                            },
                            [_vm._v(_vm._s(props.row.name))]
                          )
                        ])
                      : props.column.field === "rank"
                      ? _c("span", {
                          domProps: {
                            innerHTML: _vm._s(_vm.numberRank(props.row.rank))
                          }
                        })
                      : _c("span", [
                          _vm._v(
                            " " +
                              _vm._s(props.formattedRow[props.column.field]) +
                              " "
                          )
                        ])
                  ]
                }
              }
            ])
          })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "label-container" }, [
      _c("label", [_vm._v("Challenge:")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Partner")]),
        _c("th", [_vm._v("Schools")]),
        _c("th", [_vm._v("Parents")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Region")]),
        _c("th", [_vm._v("Schools")]),
        _c("th", [_vm._v("Parents")]),
        _c("th", [_vm._v("Readers")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [_c("tr", [_c("th"), _c("th", [_vm._v("Awarded")])])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12" }, [
      _c("div", { staticClass: "report-header" }, [
        _c(
          "h2",
          {
            staticStyle: {
              "font-weight": "200",
              color: "#224450",
              "text-shadow": "1px 1px 0 #ffffffb3"
            }
          },
          [_vm._v("Schools")]
        )
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }